import { Dialog, DialogProps, styled } from '@mui/material';
import React from 'react';

export const StyledFileDialog = styled((props: DialogProps) => (
  <Dialog fullWidth maxWidth={'lg'} sx={{ '& .MuiPaper-root': { height: '100%' } }} {...props} />
))(() => ({
  '& .MuiPaper-root': { height: '100%' },
}));
